// src/App.js

import React, { useEffect } from 'react'
import { HashRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import PrivateRoute from './routes/PrivateRoute'
import './i18n'
import { useTranslation } from 'react-i18next'
import Navbar from './components/Navbar'

import Profile from './pages/Profile'
import Login from './pages/Login'
import Register from './pages/Register'
import ForgotPassword from './pages/ForgotPassword'
import DashboardPage from './pages/DashboardPage'
import AdminUsersPage from './pages/AdminUsersPage'
import AoiDefinitionPage from './pages/AoiDefinitionPage'
import FusionSurvey from './surveys/fusion'
import SurveyReportPage from './pages/SurveyReportPage'

function AppContent() {
  const { pathname } = useLocation()

  return (
    <>
      {pathname !== '/fusion' && <Navbar />}
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />

        <Route path="/" element={<Navigate to="/ProjectsPage" replace />} />

        <Route
          path="/ProjectsPage"
          element={
            <PrivateRoute>
              <DashboardPage />
            </PrivateRoute>
          }
        />

        <Route
          path="/profile"
          element={
            <PrivateRoute>
              <Profile />
            </PrivateRoute>
          }
        />

        <Route
          path="/admin-users"
          element={
            <PrivateRoute adminOnly>
              <AdminUsersPage />
            </PrivateRoute>
          }
        />

        <Route
          path="/aoi/new"
          element={
            <PrivateRoute>
              <AoiDefinitionPage />
            </PrivateRoute>
          }
        />

        <Route
          path="/aoi/:definitionId"
          element={
            <PrivateRoute>
              <AoiDefinitionPage />
            </PrivateRoute>
          }
        />

        <Route
          path="/fusion"
          element={<FusionSurvey />}
        />

        <Route
          path="/reports/survey"
          element={
            <PrivateRoute>
              <SurveyReportPage />
            </PrivateRoute>
          }
        />

        <Route path="*" element={<Navigate to="/ProjectsPage" replace />} />
      </Routes>
    </>
  )
}

function App() {
  const { i18n } = useTranslation()

  useEffect(() => {
    document.documentElement.lang = i18n.language
  }, [i18n.language])

  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  )
}

export default App
